export type BDLCItem = {
  title: string;
  iconSrc: string;
  description: string;
};

export const bdlcItems: BDLCItem[] = [
  {
    title: "Brand Foundation",
    iconSrc: "/icons/Section-Icons/bdlcIcon/BrandFoundation.svg",
    description: "Define who you are, whom you serve, and why you exist.",
  },
  {
    title: "Brand Identity & Visual System",
    iconSrc: "/icons/Section-Icons/bdlcIcon/BrandIdentity.svg",
    description: "Build a recognizable, emotionally resonant brand look and feel.",
  },
  {
    title: "Digital Presence Setup",
    iconSrc: "/icons/Section-Icons/bdlcIcon/DigitalPresenceSetup.svg",
    description: "Launch with a high-performing digital footprint from day one.",
  },
  {
    title: "Brand Visibility & Launch",
    iconSrc: "/icons/Section-Icons/bdlcIcon/BrandVisibility.svg",
    description: "Create buzz, awareness, and strong early traction.",
  },
  {
    title: "Growth & Performance Optimization",
    iconSrc: "/icons/Section-Icons/bdlcIcon/GrowthOptimizaion.svg",
    description: "Move from awareness to acquisition, retention, and scale.",
  },
  {
    title: "Leadership Positioning & Community",
    iconSrc: "/icons/Section-Icons/bdlcIcon/LeaderShip.svg",
    description: "Move from growth to industry authority and thought leadership.",
  },
  {
    title: "Brand Evolution",
    iconSrc: "/icons/Section-Icons/bdlcIcon/BrandEvolution.svg",
    description: "Position for expansion, acquisition, or new verticals.",
  },
];



